import React from 'react';
import { FaKey, FaFileDownload } from 'react-icons/fa';
import { saveAs } from 'file-saver';
import { Link as MyLink } from 'react-scroll';
import Aos from 'aos';
import 'aos/dist/aos.css';

const Screen = () => {
    const saveFile = (file) => {
        saveAs(file, 'Stephen Olayemi CV.pdf');
    };
    return (
        <div
            id="screen"
            className="myMain  min-h-screen  h-full flex items-center text-4xl"
        >
            <div className="font-bold w-full h-full min-h-screen flex items-center text-center flex-col justify-center myMainText text-white">
                <h1>
                    <b>SOFTWARE</b> <i className="text-teal-300">DEVELOPER </i>
                </h1>

                <div className="flex flex-col justify-center sm:flex-row w-full md:w-80 px-8">
                    <button
                        onClick={() =>
                            saveFile(require('../../../Stephen CV.pdf'))
                        }
                        className="border px-4 md:mx-2 w-full md:w-48 my-2 py-2 sm:py-1 sm:my-0 "
                    >
                        <h5 className="text-lg flex items-center justify-center">
                            Download CV <FaFileDownload className="ml-4" />{' '}
                        </h5>
                    </button>

                    <button className="border border-teal-300 w-full md:w-48 px-4 md:mx-2 my-2 py-2 sm:py-1 sm:my-0 ">
                        <MyLink
                            spy={true}
                            smooth={true}
                            to="contact"
                            className="text-lg flex items-center justify-center"
                        >
                            <h5>Start a project</h5>
                            <FaKey className="ml-4" />
                        </MyLink>
                    </button>
                </div>
            </div>
        </div>
    );
};
Aos.init();

export default Screen;
